/**
 * Some iOS Safari versions leave AudioContext suspended until a user gesture.
 * Howler covers most cases; this helper installs a one-shot pointerdown listener
 * that explicitly resumes if still suspended after first interaction.
 */
export function installIosUnlock(getCtxState: () => string, resume: () => void): () => void {
  const handler = () => {
    if (getCtxState() === 'suspended') resume();
    document.removeEventListener('pointerdown', handler, true);
  };
  document.addEventListener('pointerdown', handler, true);
  return () => document.removeEventListener('pointerdown', handler, true);
}
